export default [
  {
    path: '/predicoes-baixas',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Predições de Baixas Histórico',
        path: 'historico',
        component: () => import('@/views/predicoesBaixas/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Predição de Baixas' }]
        }
      },
      {
        name: 'Predições de Baixas Editar',
        path: 'edit/:id',
        component: () => import('@/views/predicoesBaixas/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Predição de Baixas', path: '/predicoes-baixas/historico' },
            { name: 'Editar' }
          ]
        }
      },
      {
        name: 'Predições de Baixas Adicionar',
        path: 'edit',
        component: () => import('@/views/predicoesBaixas/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Predição de Baixas', path: '/predicoes-baixas/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'Predições de Baixas Resultado',
        path: 'resultado/:id',
        component: () => import('@/views/predicoesBaixas/Resultado.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Predição de Baixas', path: '/predicoes-baixas/historico' },
            { name: 'Resultado' }
          ]
        }
      }
    ]
  }
];
